module.exports = __webpack_public_path__ + "img/92101.23a5a764.svg";